import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PlatformIcon from '../../../../../../img/svg/platforms'
import MarkReadyOrderModal from './MarkReadyOrderModal'
import { MarkReadyOrderButtonWrapper, MarkReadyOrderIconWrapper, MarkReadyOrderText } from './index.styled'

const MarkReadyOrderButton = React.memo(({ item }) => {
	const { t } = useTranslation()
	const [markReadyOrderModalIsOpen, setMarkReadyOrderModalIsOpen] = useState(false)
	const markedReady = item?.platformMetaData?.markedReady === true

	const handleOpenMarkReadyOrderModal = useCallback((e) => {
		e.stopPropagation()
		setMarkReadyOrderModalIsOpen(true)
	}, [])

	const handleCloseMarkReadyOrderModal = useCallback(() => {
		setMarkReadyOrderModalIsOpen(false)
	}, [])

	return (
		<>
			{!markedReady &&
				<MarkReadyOrderButtonWrapper type="button"
				                             onClick={handleOpenMarkReadyOrderModal}
				                             onDoubleClick={handleOpenMarkReadyOrderModal}>
					<MarkReadyOrderIconWrapper>
						<PlatformIcon icon="WOLT_PLUGIN-LIGHT" />
					</MarkReadyOrderIconWrapper>
					<MarkReadyOrderText>{t('order.table.mark_ready_button')}</MarkReadyOrderText>
				</MarkReadyOrderButtonWrapper>}

			<MarkReadyOrderModal isOpen={markReadyOrderModalIsOpen}
			                     close={handleCloseMarkReadyOrderModal}
			                     order={item} />
		</>
	)
})

MarkReadyOrderButton.displayName = 'MarkReadyOrderButton'
export default MarkReadyOrderButton
